import ResourceManager from "@/components/admin/ResourceManager";

export default function ProductsAdmin() {
  return (
    <ResourceManager
      collection="products" title="Produits Hardware" subtitle="Gérez votre catalogue de matériel informatique."
      columns={[
        { key: "reference", label: "Réf." },
        { key: "name", label: "Nom" },
        { key: "brand", label: "Marque" },
        { key: "category", label: "Catégorie" },
        { key: "price", label: "Prix" },
      ]}
      fields={[
        { name: "reference", label: "Référence", type: "text" },
        { name: "name", label: "Nom", type: "text" },
        { name: "brand", label: "Marque", type: "text" },
        { name: "category", label: "Catégorie", type: "select", options: ["Ordinateurs", "Laptops", "Serveurs", "Écrans", "Imprimantes", "Routeurs", "Switches", "Firewalls", "Onduleurs", "NAS", "Accessoires"] },
        { name: "short_desc", label: "Description courte", type: "textarea" },
        { name: "description", label: "Description", type: "textarea" },
        { name: "caracteristiques", label: "Caractéristiques", type: "list" },
        { name: "price", label: "Prix", type: "text", placeholder: "450 000 FCFA ou Sur devis" },
        { name: "availability", label: "Disponibilité", type: "select", options: ["En stock", "Sur commande", "Rupture"] },
        { name: "image", label: "Image (URL)", type: "text" },
        { name: "featured", label: "Produit vedette", type: "boolean" },
        { name: "seo_title", label: "SEO — Meta title", type: "text" },
        { name: "seo_description", label: "SEO — Meta description", type: "textarea" },
      ]}
    />
  );
}
